import React from 'react'
import { Dropdown } from 'react-bootstrap'
import { MdCheck, MdOutlineComputer, MdOutlineDarkMode, MdOutlineLightMode } from 'react-icons/md'
import { useTheme } from '../context/theme'
import './ThemeMenu.css'

// Tema do portal, ao lado do nome do usuário no topo. O ícone mostra a escolha atual; a escolha fica neste navegador
export const THEME_OPTIONS = [
  { mode: 'light', label: 'Claro', Icon: MdOutlineLightMode },
  { mode: 'dark', label: 'Escuro', Icon: MdOutlineDarkMode },
  { mode: 'system', label: 'Sistema', Icon: MdOutlineComputer },
]

const ThemeMenu = () => {
  const { mode, setMode } = useTheme()
  const current = THEME_OPTIONS.find((option) => option.mode === mode) || THEME_OPTIONS[2]
  const CurrentIcon = current.Icon

  return (
    <Dropdown align='end' className='theme-menu'>
      <Dropdown.Toggle variant='' className='theme-menu-toggle' aria-label={`Tema: ${current.label}`} title={`Tema: ${current.label}`}>
        <CurrentIcon size={20} aria-hidden='true' />
      </Dropdown.Toggle>
      <Dropdown.Menu>
        <Dropdown.Header>Tema</Dropdown.Header>
        {THEME_OPTIONS.map(({ mode: option, label, Icon }) => (
          <Dropdown.Item
            key={option}
            as='button'
            type='button'
            role='menuitemradio'
            aria-checked={option === mode}
            className='theme-menu-item'
            onClick={() => setMode(option)}
          >
            <Icon size={18} aria-hidden='true' />
            <span>{label}</span>
            {option === mode ? <MdCheck className='theme-menu-check' size={18} aria-hidden='true' /> : ''}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  )
}

export default ThemeMenu
